import * as React from 'react';
import EnvironmentProvider from './EnvironmentProvider';
import LanguageProvider from './LanguageProvider';
import TranslationsContextWrapper from './TranslationsContextWrapper';
const CommonComponentsProvider = (props) => {
    const { children, translations, disableTranslationsStatistics } = props;
    return (React.createElement(EnvironmentProvider, { app: props.app || 'public', tier: props.tier, isParent: true },
        React.createElement(LanguageProvider, { lang: props.language, isParent: true },
            React.createElement(TranslationsContextWrapper, { translations: translations, disableStatistics: disableTranslationsStatistics, isTestEnvironment: props.isTestEnvironment }, children))));
};
export default CommonComponentsProvider;
